import { AHIcon } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { FormattedMessage } from "react-intl";
import { TodoListItemProducts_StoreProduct$key } from "./__generated__/TodoListItemProducts_StoreProduct.graphql";
import { TodoListItemFooterLabel } from "./TodoListItemFooterItem";

export function TodoListItemProducts(props: {
  products: TodoListItemProducts_StoreProduct$key;
  maxWidth?: number;
}) {
  const products = useFragment(
    graphql`
      fragment TodoListItemProducts_StoreProduct on StoreProduct
      @relay(plural: true) {
        name
      }
    `,
    props.products
  );

  if (products.length === 0) {
    return null;
  }

  return (
    <>
      {products.length === 1 ? (
        <TodoListItemProductsSingleProduct
          productTitle={products[0]?.name ?? ""}
          maxWidth={props.maxWidth}
        />
      ) : (
        <TodoListItemProductsMultipleProducts
          numberOfProducts={products.length}
        />
      )}
    </>
  );
}

export function TodoListItemProductsSingleProduct(props: {
  productTitle: string;
  maxWidth?: number;
}) {
  return (
    <>
      <AHIcon
        spaceRight="xsmall"
        type="product"
        color="text-washed"
        size="small"
      />
      <TodoListItemFooterLabel maxWidth={props.maxWidth}>
        {props.productTitle}
      </TodoListItemFooterLabel>
    </>
  );
}

export function TodoListItemProductsMultipleProducts(props: {
  numberOfProducts: number;
}) {
  return (
    <>
      <AHIcon
        spaceRight="xsmall"
        type="product"
        color="text-washed"
        size="small"
      />
      <TodoListItemFooterLabel>
        <FormattedMessage
          defaultMessage="{count} products"
          description="TodoListItemProduct number of products"
          values={{
            count: props.numberOfProducts,
          }}
        />
      </TodoListItemFooterLabel>
    </>
  );
}
